exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-services-bundle-table th[data-v-19949e93],\n.product-services-bundle-table td[data-v-19949e93] {\n  vertical-align: middle;\n}\n", ""]);

// exports
